import type { Domain } from '@/config/domain/type';

export const trademarksOnlineMalaysia: Domain = {
    domain: import.meta.env.VITE_TMO_MY_DOMAIN,
    website: 'https://www.trademarksmalaysia.my',
    shortCode: 'TMO-MY',
    markSource: '',
    title: 'Apply for your Malaysia trademark',
    name: 'Trademarks Online Malaysia',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your Malaysia trademark by entering your trademark or logo.',
    logo: '/img/TM-Logo-White-Thin.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/pricing' },
        { label: 'FAQ', url: '/trademark-questions' },
        { label: 'About', url: '/about-us' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '',
    gtmId: 'GTM-TWBXXN2M',
};
